import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/logo.png";

const HeaderContainer = ({ onSectionChange }) => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClick = () => {
    if (onSectionChange) {
      onSectionChange('menu');
    }
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleOnlineMagazaClick = () => {
    if (onSectionChange) {
      onSectionChange('online-magaza');
    }
    navigate('/online-magaza');
    setIsMenuOpen(false);
  };

  return (
    <nav style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem 2rem",
      background: "#fff",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      position: "relative",
    }}>
      {/* Sol Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={logo} alt="Logo" style={{ height: 40 }} />
      </div>

      {/* Sağ Hamburger Menü */}
      {isPhone && (
        <button 
          onClick={toggleMenu}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer'
          }}
        >
          {isMenuOpen ? '✖' : '☰'}
        </button>
      )}

      {/* Mobil Menü İçeriği */}
      {isPhone && isMenuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#f2f2f2',
          padding: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
          <span style={{ cursor: 'pointer' }} onClick={handleMenuClick}>Menü</span>
          <span style={{ cursor: 'pointer' }} onClick={handleOnlineMagazaClick}>Online Mağaza</span>
        </div>
      )}
    </nav>
  );
};

export default HeaderContainer; 